import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import CalendarToday from '@material-ui/icons/CalendarToday';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedDate } from 'react-intl';

import { SPACING_UNIT } from '../../constant/spacing';
interface Props {
  dueDate: Date;
  className?: string;
}
const DeliveryDueDate = ({ dueDate, className }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <CalendarToday style={{ fontSize: 20 }} />
    <Spacer />
    <FormattedMessage id="delivery_due_date.label" />
    :<Spacer />
    <FormattedDate value={dueDate} year="numeric" month="short" day="2-digit" />
  </Root>
);

const Root = styled(Typography)({
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '0.8125rem',
});

const Spacer = styled('span')({
  marginRight: SPACING_UNIT,
});

export default DeliveryDueDate;
